import React from 'react';
import {
    Dialog, DialogActions, DialogContent,
    DialogContentText, DialogTitle, Button
} from '@mui/material';

export default function DeleteDialog({ open, onClose, onConfirm, t }) {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{t("confirm_delete_title")}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {t("confirm_delete_text")}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t("cancel")}</Button>
                <Button color="error" onClick={onConfirm}>{t("delete")}</Button>
            </DialogActions>
        </Dialog>
    );
}
